import { fetchEntries, fetchOneEntry } from '@builder.io/sdk-vue';
import {generateKeyFromObject} from "../utils/string";

export class BuilderService {


    private api_key: string;
    private customClientErrorHandler: ReturnType<typeof useNuxtApp>['$customClientErrorHandler'];

    constructor(api_key: string) {
        this.api_key = api_key;
        const { $customClientErrorHandler } = useNuxtApp();
        this.customClientErrorHandler = $customClientErrorHandler;
    }

    async getList(
        model = 'pages', query = {},
        sort = {}, limit = 10, offset = 0,
        nuxtApp: any = null, redisCacheBurst = false
    ) {

        let locale = 'nl-NL'
        if(nuxtApp && nuxtApp.$i18n){
            const i18n = { global: nuxtApp.$i18n };
            locale: i18n.global.locale.value
        }

        let apiKey = this.api_key;

        let options  = {
            locale,
            model,
            apiKey,
            query,
            sort,
            limit,
            offset,
            userAttributes: { locale: undefined }
        }

        if(import.meta.server){

            let params = {
                options,
                key : model+'-'+await generateKeyFromObject(options),
                redisCacheBurst
            }

            return useAjaxServer("/api/builder/fetch", {
                method: "post",
                params,
            })
        }

        try {
            return fetchEntries(options);
        } catch (error) {

            let errorMeta = {
                model,
                query,
                builderServiceError: true,
            }

            this.customClientErrorHandler (
                error,
                'high',
                'Builder Service Error - trying to fetch builder list using getList()',
                errorMeta
            );
            throw error;
        }
    }

    async getItem(model = 'pages', userAttributes = {}, options = {}, query = {},
                  nuxtApp: any = null)
    {
        let apiKey = this.api_key;
        const i18n = { global: nuxtApp?nuxtApp.$i18n:null };
        const builderOptions = {
            locale: i18n?.global?.locale?.value,
            model,
            apiKey,
            query,
            userAttributes,
            options,
            cachebust: true,
            cacheSeconds: 0,
        };

        try {
            return await fetchOneEntry(builderOptions);
        } catch (error) {
            let errorMeta = {
                model,
                query,
                userAttributes,
                builderServiceError: true,
            }

            this.customClientErrorHandler (
                error,
                'high',
                'Builder Service Error - trying to fetch items using getItem()',
                errorMeta
            );
            throw error;
        }
    }

    async getContentModel(model: string, apiKey: string) {
        try {
          const url = useRuntimeConfig().public.builderBaseUrl + model + `?apiKey=${apiKey}`;
          return await useAjax(url, {
            headers: {
              accept: "*/*"
            },
            show_notifications: false,
            show_loading_indicator: false
          });
        } catch (error) {
          const { $customClientErrorHandler } = useNuxtApp();
          let errorMeta = {
            model,
            apiKey,
            builderServiceError: true,
          }
  
          $customClientErrorHandler (
            error,
            'high',
            'Builder Service Error - trying to fetch content model using getContentModel()',
            errorMeta
          );
          throw error;
        }
    }
      
}
